import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import AppDocTabs, { AppNotFound } from "../components/AppDocTabs";
import { getApp } from "../data/apps";
import { SITE, mailto } from "../data/site";
import "../styles/docs.css";

const INFO = ["앱 버전", "기기 모델과 OS 버전", "문제가 생긴 화면과 상황"];

export default function SupportPage() {
  const { slug = "" } = useParams();
  const app = getApp(slug);
  const [open, setOpen] = useState<number[]>([0]);

  useEffect(() => {
    if (app) document.title = `${app.name} 고객지원 | kwangbok.me`;
  }, [app]);

  if (!app) return <AppNotFound slug={slug} />;
  const faq = app.faq ?? [];
  const toggle = (i: number) =>
    setOpen((o) => (o.includes(i) ? o.filter((x) => x !== i) : [...o, i]));
  const body = INFO.map((t) => `${t}: `).join("\n") + "\n";

  return (
    <SiteLayout crumb={`apps / ${app.slug} / support`}>
      <div className="docs">
        <AppDocTabs app={app} current="support" />
        <div className="docs-split docs-split--aside">
          <div className="docs-card docs-pad">
            <h1 className="docs-h1">고객지원</h1>
            <h2 className="docs-label docs-mono docs-muted">faq</h2>
            {faq.length === 0 ? (
              <p className="docs-muted">등록된 질문이 아직 없습니다. 직접 문의해 주세요.</p>
            ) : (
              <div className="docs-faq">
                {faq.map((f, i) => {
                  const isOpen = open.includes(i);
                  return (
                    <div key={i} className="docs-faq-item">
                      <h3>
                        <button
                          type="button"
                          id={`faq-q-${i}`}
                          aria-expanded={isOpen}
                          aria-controls={`faq-a-${i}`}
                          onClick={() => toggle(i)}
                        >
                          <span className="docs-num">Q{String(i + 1).padStart(2, "0")}</span>
                          <span className="docs-faq-q">{f.q}</span>
                          <span className="docs-faq-mark" aria-hidden="true">
                            {isOpen ? "−" : "+"}
                          </span>
                        </button>
                      </h3>
                      <div
                        id={`faq-a-${i}`}
                        role="region"
                        aria-labelledby={`faq-q-${i}`}
                        className="docs-faq-a"
                        hidden={!isOpen}
                      >
                        <p>{f.a}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div className="docs-aside">
            <section className="docs-contact" aria-labelledby="docs-contact-title">
              <span className="docs-mono docs-kw">contact</span>
              <h2 id="docs-contact-title">직접 문의하기</h2>
              <p>답변은 {SITE.support_reply_days} 안에 메일로 드립니다. 아래 내용을 함께 보내 주세요.</p>
              <ul>
                {INFO.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
              <a href={mailto(`[${app.name}] 문의`, body, app.operator.email)} className="docs-btn docs-btn--light">
                {app.operator.email}
              </a>
            </section>
            <nav aria-label="바로가기" className="docs-card docs-pad docs-links">
              <span className="docs-mono docs-muted">links</span>
              {app.has_account && <Link to={`/apps/${app.slug}/delete-account`}>계정과 데이터 삭제 요청</Link>}
              <Link to={`/apps/${app.slug}/privacy`}>개인정보처리방침</Link>
              <Link to="/legal">다른 앱의 정책과 지원</Link>
            </nav>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
